import type { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faFileAlt } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const AttachedFile = ({
  title,
  url,
}: {
  title: string;
  url: string;
}) => {
  return (
    <div className="my-1">
      <FontAwesomeIcon
        icon={faFileAlt as IconProp}
        className="text-gray-100 mr-2"
      />
      <span className="mr-2 overflow-hidden overflow-ellipsis whitespace-nowrap">
        {title}
      </span>
      <a href={url} download>
        Download
      </a>
      <span className="px-1">/</span>
      <a
        href={`${url}&download=false`}
        target="_blank"
        rel="noopener noreferrer"
      >
        View
      </a>
    </div>
  );
};
